var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCocktailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.0943 108.953C95.4851 112.335 100.502 112.335 102.893 108.953L138.432 58.6813C141.241 54.7072 138.399 49.2178 133.533 49.2178H62.4547C57.5879 49.2178 54.7459 54.7072 57.5553 58.6813L93.0943 108.953Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9941 147.99V108.888",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8164 147.99H123.185",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2531 68.1508C61.3731 69.8485 58.0042 70.8263 54.4132 70.8263C43.6933 70.8263 35 62.1419 35 51.4132C35 40.6844 43.6933 32 54.4132 32C64.3864 32 72.6085 39.5288 73.7019 49.2176",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCocktailIcon);
export default __webpack_public_path__ + "static/media/cocktail-icon.72631e1dbe17380afae359ecac007583.svg";
export { ForwardRef as ReactComponent };